import React, {useState} from 'react';
import styled from 'styled-components';
import {Form} from 'components/antd';
import useSearchParams from '../../useSearchParams';
import {InputNumber} from 'components';

const EmployeeNumberFilter = () => {
  const {query, setQuery} = useSearchParams();
  const {employeeNumber} = query;
  const [from, setFrom] = useState(employeeNumber?.from);
  const [to, setTo] = useState(employeeNumber?.to);

  return (
    <Container>
      <Form.Item>
        <StyledInputNumber
          min={1}
          value={from}
          onChange={(value) => setFrom(value)}
          onBlur={() => setQuery({employeeNumber: {from: from, to: to}})}
        />
        <span> 人 〜 </span>
        <StyledInputNumber
          min={1}
          value={to}
          onChange={(value) => setTo(value)}
          onBlur={() => setQuery({employeeNumber: {from: from, to: to}})}
        />
        <span> 人</span>
      </Form.Item>
    </Container>
  );
};

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

const StyledInputNumber = styled(InputNumber)`
  border: 1px solid rgb(217, 217, 217) !important;
  width: 122px;
`;

export default EmployeeNumberFilter;
